import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

export const promptsApi = createApi({
  reducerPath: "promptsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL}/v2`,
  }),
  tagTypes: ["Prompts"],
  endpoints: (builder) => ({
    // Get All Prompts
    getAllPrompts: builder.query({
      query: (token) => `/${token}/prompts`,
      providesTags: ["Prompts"],
    }),

    // Get Specific Prompt
    getPrompt: builder.query({
      query: ({ token, name }) => ({
        url: `/${token}/prompt`,
        method: "GET",
        body: { name },
      }),
      providesTags: (result, error, { name }) => [
        { type: "Prompts", id: name },
      ],
    }),

    // Create/Update Prompt
    createUpdatePrompt: builder.mutation({
      query: ({ token, promptData }) => ({
        url: `/${token}/prompt`,
        method: "POST",
        body: promptData,
      }),
      invalidatesTags: ["Prompts"],
    }),

    // Delete Prompt
    deletePrompt: builder.mutation({
      query: ({ token, name }) => ({
        url: `/${token}/prompt`,
        method: "DELETE",
        body: { name },
      }),
      invalidatesTags: ["Prompts"],
    }),
  }),
});

export const {
  useGetAllPromptsQuery,
  useGetPromptQuery,
  useCreateUpdatePromptMutation,
  useDeletePromptMutation,
} = promptsApi;

export default promptsApi;
